import React, { useEffect, useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
import { trackButtonClick, trackStandardEvent } from '../utils/pixel';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  const handleMegaKitClick = () => {
    trackButtonClick('FinalCTA - Comprar MegaKit');
    trackStandardEvent('Purchase', {
      value: 19990,
      currency: 'ARS',
      content_name: 'Plan de Calma MegaKit'
    });
  };
  const handlePlanTotalClick = () => {
    trackButtonClick('FinalCTA - Comprar Plan Total');
    trackStandardEvent('Purchase', {
      value: 29990,
      currency: 'ARS',
      content_name: 'Plan de Calma Total'
    });
  };
  return <section className="py-20 md:py-28 bg-dark-green relative overflow-hidden" data-id="element-107">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-sage/20 blur-[120px] rounded-full pointer-events-none" data-id="element-108"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-109">
        <div className="max-w-4xl mx-auto text-center" data-id="element-110">
          <SectionWrapper data-id="element-111">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-playfair font-bold text-white mb-8 leading-tight" data-id="element-112">
              El próximo domingo puede ser diferente. 🧠
            </h2>

            <div className="mx-auto mb-12 text-cream/90 font-poppins text-lg md:text-xl leading-relaxed max-w-3xl" data-id="element-113">
              <p className="mb-8" data-id="element-114">
                Podés seguir improvisando cada vez que hay un berrinche,
                cediendo por cansancio y sintiendo culpa a la noche. O podés
                tener un sistema claro, saber exactamente qué decir y recuperar
                la paz en tu casa.
              </p>
              <blockquote className="border-l-4 border-gold pl-6 py-2 italic text-white text-xl md:text-2xl font-medium text-left bg-white/5 rounded-r-xl" data-id="element-115">
                "La tranquilidad de saber qué hacer cuando tu hijo explota no
                tiene precio."
              </blockquote>
            </div>
          </SectionWrapper>

          <SectionWrapper delay={0.2} data-id="element-116">
            <div className="inline-flex flex-col items-center mb-12 p-6 bg-white/10 backdrop-blur-sm rounded-2xl border border-white/20 shadow-lg" data-id="element-117">
              <span className="text-gold font-poppins text-sm font-bold tracking-widest uppercase mb-2" data-id="element-118">
                La oferta termina en
              </span>
              <div className="flex items-center gap-2 font-playfair text-3xl md:text-4xl font-bold text-white" data-id="element-119">
                <span data-id="element-120">{formatTime(timeLeft.hours)}</span>
                <span className="text-white/50" data-id="element-121">:</span>
                <span data-id="element-122">{formatTime(timeLeft.minutes)}</span>
                <span className="text-white/50" data-id="element-123">:</span>
                <span data-id="element-124">{formatTime(timeLeft.seconds)}</span>
              </div>
            </div>
          </SectionWrapper>

          <SectionWrapper delay={0.4} data-id="element-125">
            <div className="flex flex-col sm:flex-row justify-center items-center gap-6 mb-10" data-id="element-126">
              <a href="https://bovedadigital.online/cart/46514025169035:1" onClick={handleMegaKitClick} className="w-full sm:w-auto px-10 py-5 min-h-[54px] bg-white hover:bg-cream text-dark-green font-poppins font-bold text-lg rounded-xl transition-all duration-300 shadow-[0_8px_20px_rgba(255,255,255,0.2)] hover:shadow-[0_12px_25px_rgba(255,255,255,0.3)] transform hover:-translate-y-1 flex flex-col items-center" data-id="element-127">
                <span data-id="element-128">Quiero el MegaKit Plan de Calma</span>
                <span className="text-sm font-semibold opacity-80 mt-1" data-id="element-129">
                  $19.990 ARS
                </span>
              </a>

              <a href="https://bovedadigital.online/cart/46518532046987:1" onClick={handlePlanTotalClick} className="w-full sm:w-auto px-10 py-5 min-h-[54px] bg-transparent hover:bg-white/10 text-white border-2 border-white/50 font-poppins font-bold text-lg rounded-xl transition-all duration-300 flex flex-col items-center" data-id="element-130">
                <span data-id="element-131">Quiero el Plan de Calma Total</span>
                <span className="text-sm font-medium opacity-80 mt-1" data-id="element-132">
                  $29.990 ARS
                </span>
              </a>
            </div>

            <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-white/80 font-poppins font-medium" data-id="element-133">
              <span className="flex items-center gap-1.5" data-id="element-134">
                <Lock size={16} className="text-gold" data-id="element-135" /> Pago 100% seguro
              </span>
              <span className="hidden md:block w-1.5 h-1.5 rounded-full bg-white/30" data-id="element-136"></span>
              <span className="flex items-center gap-1.5" data-id="element-137">
                <Zap size={16} className="text-gold" data-id="element-138" /> Acceso en 5 minutos
              </span>
              <span className="hidden md:block w-1.5 h-1.5 rounded-full bg-white/30" data-id="element-139"></span>
              <span className="flex items-center gap-1.5" data-id="element-140">
                <ShieldCheck size={16} className="text-gold" data-id="element-141" /> Garantía 7 días
              </span>
              <span className="hidden md:block w-1.5 h-1.5 rounded-full bg-white/30" data-id="element-142"></span>
              <span className="flex items-center gap-1.5" data-id="element-143">
                <CreditCard size={16} className="text-gold" data-id="element-144" /> MercadoPago ·
                Tarjeta
              </span>
            </div>
          </SectionWrapper>
        </div>
      </div>
    </section>;
}